<template>
    <validation-provider :rules="rules" v-slot="validationContext" :name="myId">
        <b-form-group class="formGroup" :id="`input-group-${myId}`" :label="myLabel" :label-for="`input-${myId}`"
            label-class="text-truncate" v-bind="formGroupCols">
            <template v-if="tooltip" v-slot:label>
                <label :for="`input-${myId}`" class="col-auto col-form-label text-truncate">{{ myLabel }}</label>
                <font-awesome-icon icon="question-circle" class="text-info" v-b-tooltip.hover :title="tooltip" />
            </template>
            <slot :state="getValidationState(validationContext)"></slot>
            <default-form-invalid-feedback :vc="validationContext"></default-form-invalid-feedback>
        </b-form-group>
    </validation-provider>
</template>

<script>
import DefaultFormInvalidFeedback from '@/components/shared/DefaultFormInvalidFeedback.vue'
import { FormGroupDefaultCols } from '@/types/form-default-props'
import { ValidationProvider } from 'vee-validate'
import { RandomId } from '@/mixins/random-id.mixin'

export default {
    components: { DefaultFormInvalidFeedback, ValidationProvider },
    mixins: [RandomId],
    props: {
        rules: {
            type: String,
            default: 'required'
        },
        label: {
            type: String,
            default: 'Input Sem Nome'
        },
        tooltip: {
            type: String,
            required: false
        },
        noLabel: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            formGroupCols: FormGroupDefaultCols,
            myId: null,
        }
    },
    computed: {
        myLabel() {
            return this.noLabel ? '' : `${this.label}${this.rules.includes('required') ? ' *' : ''}`
        }
    },
    methods: {
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        }
    },
    created() {
        this.myId = this.generateId(10)
    }
}
</script>
